import { ChronoUnit, Duration } from "@js-joda/core";
import { T } from "services/lang/LanguageService";

export const TIME_UNITS = [
  {
    value: ChronoUnit.SECONDS,
    enumValue: "SECONDS",
    label: T("time.seconds"),
  },
  {
    value: ChronoUnit.MINUTES,
    enumValue: "MINUTES",
    label: T("time.minutes"),
  },
  {
    value: ChronoUnit.HOURS,
    enumValue: "HOURS",
    label: T("time.hours"),
  },
  {
    value: ChronoUnit.DAYS,
    enumValue: "DAYS",
    label: T("time.days"),
  },
  {
    value: ChronoUnit.WEEKS,
    enumValue: "WEEKS",
    label: T("time.weeks"),
  },
  {
    value: ChronoUnit.MONTHS,
    enumValue: "MONTHS",
    label: T("time.months"),
  },
  {
    value: ChronoUnit.YEARS,
    enumValue: "YEARS",
    label: T("time.years"),
  },
];

export const TIME_UNITS_WITHOUR_SECONDS = TIME_UNITS.filter(option => option.value !== ChronoUnit.SECONDS)

const CHRONO_TO_DAYS = [ChronoUnit.SECONDS, ChronoUnit.MINUTES, ChronoUnit.HOURS, ChronoUnit.DAYS];
const CHRONO_FROM_DAYS = [ChronoUnit.DAYS, ChronoUnit.WEEKS, ChronoUnit.MONTHS, ChronoUnit.YEARS];

export const TIME_UNITS_TO_DAYS = TIME_UNITS.filter(unit => CHRONO_TO_DAYS.includes(unit.value));
export const TIME_UNITS_FROM_DAYS = TIME_UNITS.filter(unit => CHRONO_FROM_DAYS.includes(unit.value))

export const durationMinUnit = (duration: Duration): ChronoUnit => {
  if (duration.toDays() > 0) {
    return ChronoUnit.DAYS;
  }
  if (duration.toHours() > 0) {
    return ChronoUnit.HOURS;
  }
  if (duration.toMinutes() > 0) {
    return ChronoUnit.MINUTES;
  }
  return ChronoUnit.SECONDS;
};

export const getValueForUnit = (duration: Duration, unit: ChronoUnit): number => {
  if (unit === ChronoUnit.DAYS) {
    return duration.toDays();
  }
  if (unit === ChronoUnit.HOURS) {
    return duration.toHours();
  }
  if (unit === ChronoUnit.MINUTES) {
    return duration.toMinutes();
  }
  return duration.seconds();
};

export type TimeOptionKeys = keyof typeof TimeOptions;

export const TimeOptions = {
  DAYS: {
    value: T("time.daily"),
    duration: Duration.ofDays(1),
    timeFormat: "MM-dd",
    name: "DAYS"
  },
  HOURS: {
    value: T("time.hourly"),
    duration: Duration.ofHours(1),
    timeFormat: "HH:mm",
    name: "HOURS"
  },
};
